import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Témoignages d'étudiants" className="bg-transparent" data-id="element-181" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" data-id="element-182" data-mp="3fy2ytulpdq2z">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-183" data-mp="3b0ucrixfp1wg">
          🗣️ Témoignages réels de personnes qui ont commencé
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-184" data-mp="36wwgrh3eo77m">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-185" data-mp="2x0jlwfw4jnba" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}